import { VehicleV2 } from 'lib/AutolistAPI';
import Modal from 'react-modal';
import { useMedia } from 'react-use';
import { screen } from 'components/styles/variables';
import { srpTileStyles } from './styles';

interface SrpTileProps {
  isModalOpen: boolean;
  vehicle: VehicleV2;
  onClose: () => void;
}

export default function SrpTile({ isModalOpen, vehicle, onClose }: SrpTileProps): JSX.Element {
  const isDesktop = useMedia(`(min-width: ${screen.smMin})`);

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        style={srpTileStyles(isDesktop)}
        htmlOpenClassName="html-modal-open"
        shouldCloseOnOverlayClick={true}
        onRequestClose={onClose}
      >
        testing {vehicle.vin}
      </Modal>
    </>
  );
}
